import type { App } from "vue";
import * as components from "@/branchmanager/app/components/components.module";

export function useAllEmpChComponents(app: App) {
    for (const componentKey of Object.keys(components)) {
        const component = components[componentKey as keyof typeof components];
        app.component(componentKey, component);
    }
}